module.exports = __webpack_public_path__ + "static/media/peter_hartz.72aba657.png";